// extracted by mini-css-extract-plugin
export var main = "SnapScrollContainer-module--main--fz0r1";
export var snapContainer = "SnapScrollContainer-module--snapContainer--w2vII";